// ── Shared across all pages ──

// Cart state
let cartQty = parseInt(localStorage.getItem('lc-qty') || '0');
let cartOpen = false;

function initCart() {
  updateCartBadge();
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  if (overlay) overlay.addEventListener('click', closeCart);
}

function openCart() {
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
  cartOpen = true;
}
function closeCart() {
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
  cartOpen = false;
}
function addToCart(qty) {
  cartQty = (cartQty || 0) + (qty || 1);
  localStorage.setItem('lc-qty', cartQty);
  updateCartBadge();
  updateCartPanel();
  showCartFeedback();
  openCart();
}
function updateQty(d) {
  cartQty = Math.max(1, cartQty + d);
  localStorage.setItem('lc-qty', cartQty);
  const el = document.getElementById('qty-num');
  if (el) el.textContent = cartQty;
  updateCartDisplay();
}
function updateCartBadge() {
  const b = document.getElementById('cart-badge');
  if (!b) return;
  if (cartQty > 0) { b.textContent = cartQty; b.style.display = 'flex'; }
  else b.style.display = 'none';
}
function updateCartPanel() {
  const empty = document.getElementById('cart-empty');
  const items = document.getElementById('cart-items');
  const foot = document.getElementById('cart-foot');
  if (cartQty > 0) {
    if (empty) empty.style.display = 'none';
    if (items) items.style.display = 'block';
    if (foot) foot.style.display = 'block';
  }
  updateCartDisplay();
}
function updateCartDisplay() {
  const total = 89 * cartQty;
  const remain = Math.max(0, 500 - total);
  const totalEl = document.getElementById('cart-total');
  const shipEl = document.getElementById('ship-label');
  const fillEl = document.getElementById('ship-fill');
  const qtyEl = document.getElementById('qty-num');
  if (totalEl) totalEl.textContent = total.toFixed(2).replace('.', ',') + ' €';
  if (shipEl) shipEl.textContent = remain > 0 ? remain + ' € avant la livraison gratuite' : '✓ Livraison gratuite appliquée !';
  if (fillEl) fillEl.style.width = Math.min(100, total / 500 * 100) + '%';
  if (qtyEl) qtyEl.textContent = cartQty;
}
function showCartFeedback() {
  const btn = document.querySelector('.atc-btn');
  if (!btn) return;
  const orig = btn.textContent;
  btn.textContent = '✓ Ajouté au panier !';
  btn.style.opacity = '.85';
  setTimeout(() => { btn.textContent = orig; btn.style.opacity = '1'; }, 2000);
}

// Scroll reveal
function initReveal() {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .08 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
}

// Smooth scroll
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id === '#') return;
      const t = document.querySelector(id);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
}

// Mobile menu
function initMobileMenu() {
  const btn = document.getElementById('menu-btn');
  const menu = document.getElementById('mobile-menu');
  const close = document.getElementById('menu-close');
  if (btn) btn.addEventListener('click', () => { menu.classList.add('open'); document.body.style.overflow = 'hidden'; });
  if (close) close.addEventListener('click', () => { menu.classList.remove('open'); document.body.style.overflow = ''; });
}

// FAQ
function initFaq() {
  document.querySelectorAll('.faq-item').forEach(item => {
    item.addEventListener('toggle', () => {
      const span = item.querySelector('summary span');
      if (span) span.textContent = item.open ? '−' : '+';
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initCart();
  initReveal();
  initSmoothScroll();
  initMobileMenu();
  initFaq();
  updateCartPanel();
});
